import { useContext } from 'react';

import { ChatContext } from '@/contexts/chat.context';
import { ChatContextType } from '@/features/chat';

export const useChat = (): ChatContextType => useContext(ChatContext);
